const consentToCookies = (state = false, action) => {
  switch (action.type) {
      case 'GIVE_CONSENT_TO_COOKIES':
          return action.consent
      default:
          return state
  }
}

export default consentToCookies;